import add from '../node_modules/date-fns/esm/add/index.js';
import parseDate from './parse-date.js';
import isObject from '../type-check/is-object.js';

/**
 * @func addTime
 * @param {date} date - initial date
 * @param {object} duration - object with amount of time to be added (accepts years, months, days, hours, minutes, seconds)
 * @return {date}
 * @desc Adds time to a given date. When adding months creates a date that doesn't exist, date-fns changes the month and day. For example addTime('1/31/2021', { months: 1 }) returns a date object with a date of Feb 28, 2021.
 * ```js
 * addTime('1/1/2020', { years: 2, months: 1 });
 * // returns a date object with a date of February 1st 2022
 * ```
 * @memberof module:Date
 * @instance
 */
function addTime(date, duration) {
    const parsedDate = parseDate(date);
    if (!parsedDate)
        return null;
    if (!isObject(duration))
        return parsedDate;
    return add(parsedDate, duration);
}

export { addTime as default };
